import { render, staticRenderFns } from "./ContractWorkspace.vue?vue&type=template&id=16f6d4e8"
import script from "./ContractWorkspace.vue?vue&type=script&lang=js"
export * from "./ContractWorkspace.vue?vue&type=script&lang=js"
import style0 from "./workspace.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./consultation.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports